<i18n locale="en">
  {
    "labels": {
      "link-to": "Link To",
      "description": "Select a link, page, or action the card opens when clicked."
    },
    "options": {
      "external": "URL",
      "page": "Page",
      "action": "Action"
    }
  }
  </i18n>

<template>
  <div class="flex-col gap-4">
    <OwnType :text="t('labels.description')" />

    <OwnInputContainer :label="t('labels.link-to')">
      <OwnSegmentedControl v-model="selectedValue" :options="options" />
    </OwnInputContainer>

    <UrlForm
      v-if="selectedValue === 'external'"
      :action-config="modelValue"
      @update="
        onFormControlUpdate($event.controlName, $event.value, $event.status)
      "
    />

    <PageForm
      v-if="selectedValue === 'page'"
      :action-config="modelValue"
      @update="onActionUpdate"
    />

    <ActionForm
      v-if="selectedValue === 'action'"
      :action-config="modelValue"
      @update="onActionUpdate"
    />
  </div>
</template>

<script>
import { useI18n } from 'vue-i18n'

import { OwnInputContainer } from '@/ui/OwnInputContainer'
import { OwnSegmentedControl } from '@/ui/OwnSegmentedControl'
import { OwnType } from '@/ui/OwnType'

import ActionForm from '../../content/editor/action-forms/ActionForm.vue'
import PageForm from '../../content/editor/action-forms/PageForm.vue'
import UrlForm from '../../content/editor/action-forms/UrlForm.vue'

export default {
  name: 'CardLinkEditor',
  components: {
    ActionForm,
    OwnInputContainer,
    OwnSegmentedControl,
    OwnType,
    PageForm,
    UrlForm,
  },
  props: {
    modelValue: { default: null, type: Object },
  },
  emits: ['update'],
  setup() {
    const { t } = useI18n()

    return { t }
  },
  data() {
    return {
      options: ['external', 'page', 'action'].map((value) => ({
        label: this.t(`options.${value}`),
        value,
      })),
      selectedValue: 'external',
    }
  },
  beforeMount() {
    const { modelValue } = this

    this.selectedValue = modelValue?.type ?? 'external'
  },
  methods: {
    normalizeAction(update) {
      if (!update) return update
      if (!update.params) return update

      return {
        ...update,
        params: {
          ...update.params,
          label: '',
        },
      }
    },
    onActionUpdate(update) {
      this.$emit('update', this.normalizeAction(update))
    },
    onFormControlUpdate(controlName, newValue, status) {
      if (controlName !== 'url' || !status.valid) return

      this.$emit(
        'update',
        this.normalizeAction({
          params: { label: '', url: newValue },
          type: 'external',
        })
      )
    },
  },
}
</script>
